const { default: ChangePasswordModal } = require('./ChangePasswordModal');

export default ChangePasswordModal;
